import { render, staticRenderFns } from "./DesignRirekisho002Edit.vue?vue&type=template&id=0ad395de&scoped=true"
import script from "./DesignRirekisho002Edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekisho002Edit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DesignRirekisho002Edit.vue?vue&type=style&index=0&id=0ad395de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad395de",
  null
  
)

export default component.exports